"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncAction = void 0;
var mobx_1 = require("mobx");
function asyncAction(inputFunction) {
    return mobx_1.flow(inputFunction);
}
exports.asyncAction = asyncAction;
//# sourceMappingURL=asyncAction.js.map